import { Calendar, User } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import type { PublicPatient } from '../types';

function genderLabel(g: string | null): string | null {
  if (!g) return null;
  if (g === 'M') return 'Male';
  if (g === 'F') return 'Female';
  return 'Other';
}

export function PublicChartHeader({ patient }: { patient: PublicPatient | null }) {
  if (!patient) return null;
  const initials = (patient.display_name ?? 'UK')
    .split(/[\s,]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
  const gender = genderLabel(patient.gender);

  return (
    <section className="rounded-lg border bg-card p-5">
      <div className="flex items-start gap-4">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary text-lg font-semibold">
          {initials || 'UK'}
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="text-xl font-semibold">{patient.display_name ?? 'Unknown patient'}</h2>
          <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-sm text-muted-foreground">
            {patient.age !== null && (
              <span className="flex items-center gap-1">
                <User className="h-3.5 w-3.5" /> {patient.age}y{gender ? `, ${gender}` : ''}
              </span>
            )}
            {patient.dob && (
              <span className="flex items-center gap-1">
                <Calendar className="h-3.5 w-3.5" /> DOB: {patient.dob}
              </span>
            )}
          </div>
        </div>
        <Badge variant="outline" className="shrink-0 font-mono text-xs">Read-only</Badge>
      </div>
    </section>
  );
}
